webpackJsonp([47925944401411],{

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/psychologue-a-montpellier.5825a2ff.jpg";

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _psychologueAMontpellier = __webpack_require__(444);
	
	var _psychologueAMontpellier2 = _interopRequireDefault(_psychologueAMontpellier);
	
	var _meta = __webpack_require__(16);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var metadata = {
	  title: 'Pourquoi consulter ? | Psychologue clinicienne les arceaux | Morgane Laroche',
	  description: 'Quelles émotions, situations ou événements de vie peuvent nous conduire à venir consulter un psychologue ? Une liste non-exhaustive. Spécificité de cette démarche. psychologue montpellier – psychologue les arceaux'
	};
	
	var PourquoiConsulter = function PourquoiConsulter() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_meta2.default, { title: metadata.title, description: metadata.description }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container container--page' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'container__block-title' },
	        'POURQUOI CONSULTER ?'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container__content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container__illustration' },
	          _react2.default.createElement('img', {
	            itemProp: 'image',
	            src: _psychologueAMontpellier2.default,
	            alt: 'pourquoi consulter un psychologue, psychologue, psychologue montpellier, avis psychologue, psychologue clinicienne quartier des arceaux, cabinet de psychologie \xE0 Montpellier, psychologue clinicienne'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container__block container__block-intro' },
	          _react2.default.createElement(
	            'p',
	            { className: 'u-paragraphe' },
	            _react2.default.createElement(
	              'span',
	              { className: 'u-bold' },
	              'Toute situation de souffrance'
	            ),
	            ', de mal \xEAtre, toute p\xE9riode de changement, de crise, de mutation, en lien avec la sph\xE8re personnelle, professionnelle, affective ou familiale, m\xE9rite d\u2019\xEAtre abord\xE9e lors d\u2019une consultation avec un psychologue.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container__block' },
	        _react2.default.createElement(
	          'p',
	          { className: 'u-paragraphe u-bold' },
	          'Je vous re\xE7ois et vous accompagne pour faire face \xE0 des situations telles que :'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'container__content-list u-mb' },
	          _react2.default.createElement(
	            'li',
	            null,
	            'la perte, le deuil d\u2019un proche'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'l\u2019annonce d\u2019une maladie, d\u2019un handicap, l\u2019accompagnement d\u2019un proche'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'une rupture, un divorce difficile(s)'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'un changement dans la cellule familiale : naissance, mariage, remariage'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'un traumatisme suite \xE0 un accident, une agression physique ou verbale'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'des difficult\xE9s professionnelles : perte d\u2019emploi, mutation, reconversion, harc\xE8lement \u2026'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'des difficult\xE9s relationnelles, familiales, conjugales'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'un manque d\u2019estime de soi, de confiance, d\u2019affirmation'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'l\u2019anxi\xE9t\xE9, l\u2019angoisse, l\u2019irritabilit\xE9'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'des peurs ou phobies'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'des troubles de l\u2019alimentation'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'des troubles du sommeil'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'des probl\xE8mes d\u2019addiction(s) et de d\xE9pendance(s)'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'u-italic u-paragraphe' },
	          'Cette liste de difficult\xE9s ou manifestations qui peuvent nous conduire \xE0 consulter est non exhaustive et ne saurait rendre compte de la sp\xE9cificit\xE9 de cette d\xE9marche de soin, propre \xE0 chaque individu.'
	        )
	      )
	    )
	  );
	};
	exports.default = PourquoiConsulter;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pourquoi-consulter-js-9e07b6e375b125bfa08f.js